export const PACK_ATTRS = {
  text: {
    headingFont: 'font-family',
    paragraphFont: 'font-family',
    fontWeight: 'font-weight',
    fontStyle: 'font-style',
    fontSize: 'font-size',
    decoration: 'text-decoration',
    lineHeight: 'line-height',
    letterSpacing: 'letter-spacing',
    // fontColor: "color",
    marginBottom: 'margin-bottom',
  },
  border: {
    color: 'border-color',
    thickness: 'border-width',
    style: 'border-style',
  },
  textButtonSize: {
    headingFont: 'font-family',
    paragraphFont: 'font-family',
    fontWeight: 'font-weight',
    fontStyle: 'font-style',
    fontSize: 'font-size',
    decoration: 'text-decoration',
  },
};

export const SPACING_DEFAULT_NAMES = ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL', '5XL', '6XL'];

export const COLOR_KEYS_MAP: any = {
  'neutral-color1': 'gf_gs-color1-neutral',
  'neutral-color2': 'gf_gs-color2-neutral',
  'neutral-color3': 'gf_gs-color3-neutral',
  'brand-color1': 'gf_gs-color1-brand',
  'brand-color2': 'gf_gs-color2-brand',
  'brand-color3': 'gf_gs-color3-brand',
  'accent-color1': 'gf_gs-color1-accent',
  'accent-color2': 'gf_gs-color2-accent',
  'accent-color3': 'gf_gs-color3-accent',
  'accent-color4': 'gf_gs-color4-accent',
  'accent-color5': 'gf_gs-color5-accent',
  'accent-color6': 'gf_gs-color6-accent',
  'accent-color7': 'gf_gs-color7-accent',
  'default-black': 'gf_gs-black-default',
  'default-white': 'gf_gs-white-default',
  'default-transparent': 'gf_gs-transparent-default',
};

export const COLOR_KEYS_MAP_STYLE_NAME: any = {
  'brand-color2': 'Brand Color',
  'neutral-color1': 'Color 1',
  'neutral-color2': 'Color 2',
  'neutral-color3': 'Color 3',
  'accent-color1': 'Color 4',
  'accent-color2': 'Color 5',
  'accent-color3': 'Color 6',
  'brand-color1': 'Color 7',
  'brand-color3': 'Color 8',
  'accent-color7': 'Color 9',
  'accent-color4': 'Color 10',
  'accent-color5': 'Color 11',
  'accent-color6': 'Color 12',
  'default-black': 'Black',
  'default-white': 'White',
  'default-transparent': 'Transparent',
};

export const COLOR_KEYS_MAP_ORDERED: any = {
  'brand-color2': '',
  'neutral-color1': '',
  'neutral-color2': '',
  'neutral-color3': '',
  'accent-color1': '',
  'accent-color2': '',
  'accent-color3': '',
  'brand-color1': '',
  'brand-color3': '',
  'accent-color7': '',
  'accent-color4': '',
  'accent-color5': '',
  'accent-color6': '',
};

export const PRICING_LIMIT_PRESET = {
  starter: 1,
  professional: 20,
  trial: 3,
  advanced: 20,
  build: 20,
  optimize: 20,
  enterprise: 20,
  trial2022: 20,
};
